<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import {External, M} from "../../external";

  export let circleDetails, item, group = null, index, active = false, menuSize = 'compact';

  let dispatch = createEventDispatcher();
  let layout = '';
  let optionsBtn;
  let isGroup = false;
  let groupTrackedPages = 0;

  let calcBgImage = () => {
    if (item.settings.layoutImage && item.settings.layoutImageBase) {
      return `url(${External.getThumbnailsFromBase(item.settings.layoutImageBase, '240x160')}${item.settings.layoutImage})`;
    }
    return `url(${External.resources}/images/image-avatar.png')`;
  };

  let onOptions = () => {
    dispatch('options', {
      target: optionsBtn
    });
  };

  let tooltip = (element, title) => {
    let div;

    const mouseEnter = (event) => {
      if (menuSize !== 'compact') {
        return;
      }

      let rect = element.getBoundingClientRect();
      div = document.createElement('div');
      div.textContent = title;
      div.classList.add('circle-item-tooltip-name');
      div.style = `
			top: ${rect.top + 5}px;
			left: ${rect.right + 15}px;
		`;
      document.body.appendChild(div);
    }

    const mouseLeave = () => {
      if (div) {
        document.body.removeChild(div);
        div = null;
      }
    }

    element.addEventListener('mouseenter', mouseEnter);
    element.addEventListener('mouseleave', mouseLeave);

    return {
      destroy: () => {
        mouseLeave();
        element.removeEventListener('mouseenter', mouseEnter);
        element.removeEventListener('mouseleave', mouseLeave);
      }
    };
  };

  onMount(() => {
    isGroup = group && group.pageGroup === item;
    switch (item.settings?.layout) {
      case 'number':
      case 'icon':
      case 'icon-large':
      case 'image':
      case 'image-video':
        layout = item.settings.layout;
        break;
      default:
        layout = 'text';
        break;
    }
    if (isGroup) {
      groupTrackedPages = group.pages.filter(page => page.settings?.trackContentCompletion).length;
    }
  });

</script>
<div class="circle-page-item col20 f-left flex align-center no-selection style-{layout}" class:hidden-item={item.hidden} class:group-item={isGroup} class:text-only={layout === 'text'}
     class:active={active} on:click use:tooltip={item.name}>
  {#if layout === 'icon' || layout === 'icon-large'}
    <span class="circle-icon flex-none" class:small={layout === 'icon'} class:big={layout === 'icon-large'}>
      {#if item.settings.layoutIcon && item.settings.layoutIcon.length > 20}
          <span>{@html item.settings.layoutIcon}</span>
        {:else}
          <span class="material-icons-outlined">{item.settings.layoutIcon}</span>
        {/if}
    </span>
  {:else if layout === 'number'}
    <span class="circle-icon small flex-none">{index}</span>
  {:else if layout === 'image' || layout === 'image-video'}
    <div class="inner-circle-content-thumb-outer small flex-none">
      <span class="inner-circle-content-thumb" style="background-image: {calcBgImage()}"></span>
      {#if layout === 'image'}
        <span class="circle-icon flex-none compact-only">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M280-280h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>
        </span>
      {/if}
      {#if layout === 'image-video'}
      <span class="circle-video-play-btn">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
          <path d="M0 0h24v24H0z" fill="none" /><path d="M8 5v14l11-7z" />
        </svg>
      </span>
      {/if}
    </div>
  {:else if layout === 'text'}
		<span class="circle-icon flex-none compact-only">
			<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M280-280h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"></path></svg>
		</span>
  {/if}

  {#if item.settings?.showDescription && item.description || isGroup && item.settings?.showTrackingProgress}
    <div class="flex-1">
      <h4 class="circle-item-name col20 f-left">
        {item.name}
      </h4>
      {#if item.settings?.showDescription && item.description}
        <p class="col20 f-left page-description">{item.description}</p>
      {/if}
      {#if isGroup && item.settings?.showTrackingProgress && groupTrackedPages}
        <p class="col20 f-left inner-circle-desc">0/{groupTrackedPages} {M.COMPLETED}</p>
      {/if}
    </div>
  {:else}
    <h4 class="circle-item-name flex-1">{item.name}</h4>
  {/if}

  <div class="circle-item-footer flex-none flex align-center">
    {#if item.settings?.showBadge}
      <span class="circle-badge">{item.settings.badgeLabel}</span>
    {/if}
    {#if item.access?.type === 'PAID'}
      <svg class="lock-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <g fill="none">
          <path d="M0 0h24v24H0V0z"></path>
          <path d="M0 0h24v24H0V0z" opacity=".87"></path>
        </g>
        <path
          d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"></path>
      </svg>
    {/if}
    {#if item.settings?.trackContentCompletion}
      <svg class="pending-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
      </svg>
    {/if}

    {#if isGroup}
      {#if circleDetails.circle.styling?.submenuStyle === 'inline'}
        {#if group.expanded}
          <svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
               fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path
              d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          </svg>
        {:else}
          <svg class="flex-none inner-circle-toggle-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
               fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path
              d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          </svg>
        {/if}
      {:else}
        <svg class="flex-none inner-circle-toggle-icon arrow-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
             width="24px"
             fill="#000000">
          <path d="m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z" />
        </svg>
      {/if}
    {/if}
  </div>

  <div class="circle-page-controls flex align-center justify-center">
    <a class="move-handle circle-round-btn">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
    </a>
    <a class="circle-round-btn circle-effect ml-5" bind:this={optionsBtn} on:click|stopPropagation|preventDefault={onOptions}>
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none"></path>
        <path
          d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
      </svg>
    </a>
  </div>
</div>
